/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Source_TitleInputs */

const en_pc_dl_source_title = /** @type {(inputs: Pc_Dl_Source_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build PdfCraft from source`)
};

const zh_pc_dl_source_title = /** @type {(inputs: Pc_Dl_Source_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从源码编译 PdfCraft`)
};

/**
* | output |
* | --- |
* | "Build PdfCraft from source" |
*
* @param {Pc_Dl_Source_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_source_title = /** @type {((inputs?: Pc_Dl_Source_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Source_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_source_title(inputs)
	return zh_pc_dl_source_title(inputs)
});
export { pc_dl_source_title as "pc.dl.source_title" }